import { render, staticRenderFns } from "./GraficoDonut.vue?vue&type=template&id=a836a7fa&"
import script from "./GraficoDonut.vue?vue&type=script&lang=js&"
export * from "./GraficoDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports